import { FunctionsHelper } from '@shared/utils/helpers/functions.helper';
import { Component, ElementRef, EventEmitter, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PopupData } from '@models/app/modal-data.model';
import { MixpanelService } from '@services/mixpanel.service';
import { SiqIconPosition } from '@shared/utils/helpers/enum.helper';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html'
})
export class PopupComponent implements OnInit {
  onLeftAction = new EventEmitter();
  onRightAction = new EventEmitter();
  onOutsideClick = new EventEmitter();
  onClose = new EventEmitter();

  iconPositionFallback = SiqIconPosition.left;
  @ViewChild('dialogContainer') dialogContainer!: ElementRef;
  @ViewChild('closeButton') closeButton!: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PopupData,
    public dialogRef: MatDialogRef<PopupComponent>,
    private mixpanelService: MixpanelService) { }

  ngOnInit(): void {
    this.mixpanelService.trackPopupOpen(FunctionsHelper.removeHtmlTags(this.data.text), FunctionsHelper.removeHtmlTags(this.data.title));

    // Set focus to the dialog on open
    setTimeout(() => {
      this.dialogContainer.nativeElement.focus();
    }, 0);

    // Listen for clicks outside the dialog
    this.dialogRef.backdropClick().subscribe(() => {
      this.onOutsideActionClick();
    });
  }

  get iconClasses(): string {
    return `circle br-40 ${this.data.type}`;
  }

  get btnClasses(): string {
    return `${this.data.hideLeftButton ? 'w-75-p': 'w-50-p'} text-center`;
  }

  onCloseClick(): void {
    this.onClose.emit();
    this.dialogRef.close();
    this.mixpanelService.trackPopupClose(FunctionsHelper.removeHtmlTags(this.data.text), 'x', FunctionsHelper.removeHtmlTags(this.data.title));
  }

  onLeftActionClick(): void {
    this.onLeftAction.emit();
    this.mixpanelService.trackPopupClose(FunctionsHelper.removeHtmlTags(this.data.text), this.data.leftBtnTxt, FunctionsHelper.removeHtmlTags(this.data.title));
  }

  onRightActionClick(): void {
    this.onRightAction.emit();
    this.mixpanelService.trackPopupClose(FunctionsHelper.removeHtmlTags(this.data.text), this.data.rightBtnTxt, FunctionsHelper.removeHtmlTags(this.data.title));
  }

  onOutsideActionClick(): void {
    this.onOutsideClick.emit();
    this.mixpanelService.trackPopupClose(FunctionsHelper.removeHtmlTags(this.data.text), 'Dismiss', FunctionsHelper.removeHtmlTags(this.data.title));
  }

  moveFocusToCloseButton(event: Event): void {
    if (event instanceof KeyboardEvent && !event.shiftKey) { // Only when pressing "Tab" forward
      event.preventDefault(); // Prevent default tabbing behavior
      this.closeButton.nativeElement.focus();
    }
  }
}
